<template>
  <div class="notif" :class="[category, direction]">
    <div class="icon"></div>
    <div class="date">{{ formatDate(notification.date) }}</div>
    <div class="content">
      <slot>

        <template v-if="notification.notification_type === 'appointment_reminder' && notification.variables.type === 'chimio'">
          <h4>Séance de chimiothérapie {{ formatDateTime(notification.variables.date) }}</h4>
          <p>Le mini-jeu Chimiothérapie est disponible, viens gagner un nouveau badge !</p>
          <bouton url="test">Jouer au jeu</bouton></item-notif>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder' && notification.variables.type === 'myelogramme'">
          <h4>Myélogramme {{ formatDateTime(notification.variables.date) }}</h4>
          <p>Fiche myélogramme et mini-jeu disponibles. </br>Parles-en avec tes parents et le personnel de l’hôpital.</p>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder' &&
        notification.variables.type === 'conditionnement'">
          <h4>Prépation à la greffe {{ formatDateTime(notification.variables.date) }}</h4>
          <p>Fiche préparation à la greffe et mini-jeu disponibles. </br>Parles-en avec tes parents et le personnel de l’hôpital.</p>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder' &&
        notification.variables.type === 'voie-veineuse'">
          <h4>Pose de voie veineuse centrale {{ formatDateTime(notification.variables.date) }}</h4>
          <p>Fiche pose de voie veineuse et mini-jeu disponibles. </br>Parles-en avec tes parents et le personnel de l’hôpital.</p>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder' && notification.variables.type === 'transfusion'">
          <h4>Transfusion {{ formatDateTime(notification.variables.date) }}</h4>
          <p>Fiche transfusions sanguine disponible. </br>N’hésite pas à poser des questions.</p>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder' && notification.variables.type === 'visiteur'">
          <h4>{{ notification.variables.title }} {{ formatDateTime(notification.variables.date) }}</h4>
          <h4>Super, un proche vient te voir bientôt !</h4>
        </template>

        <template v-else-if="notification.notification_type === 'appointment_reminder'">
          <h4>Rendez-vous "{{ notification.variables.type }}" {{ formatDateTime(notification.variables.date) }}</h4>
        </template>

        <template v-else-if="notification.notification_type === 'child_appointment_reminder'">
          <h4>Rendez-vous "{{ notification.variables.type }}" {{ formatDateTime(notification.variables.date) }}</h4>
          <p v-if="notification.variables.title || notification.variables.comment">
            <template v-if="notification.variables.title"><b>Nom:</b> {{ notification.variables.title }}<br></template>
            <template v-if="notification.variables.comment"><b>Commentaire:</b> {{ notification.variables.comment }}</template>
          </p>
        </template>

        <template v-else-if="notification.notification_type === 'account_creation'">
          <h4>Bienvenue sur la plateforme Globulo Quest !</h4>
        </template>

        <template v-else-if="notification.notification_type === 'child_account_creation'">
          <h4>Vous avez inscrit votre enfant {{ notification.variables.name }} sur la plateforme</h4>
        </template>

        <template v-else-if="notification.notification_type === 'sub_account_creation' && me.account_type === 'child'">
          <h4>Bravo, {{ notification.variables.name }} a rejoint ta communauté !</h4>
        </template>

        <template v-else-if="notification.notification_type === 'sub_account_creation'">
          <h4>Vous avez inscrit {{ notification.variables.name }} sur la plateforme</h4>
        </template>

        <template v-else-if="notification.notification_type === 'general_survey_completed'">
          <h4>Merci d'avoir complété le sondage !</h4>
        </template>

        <template v-else-if="notification.notification_type === 'caregiver_creation'">
          <h4>{{ notification.variables.name }}, {{ SoignantDB[notification.variables.job].name }}, fait maintenant partie de ta Team de Soignants !</h4>
        </template>

        <template v-else-if="notification.notification_type.indexOf('badge_') === 0">
          <img
            class="badge-img"
            :src="require(`@/assets/images/badges/${ BadgesDB[notification.variables.badge].image }`)"
            />
          <h4>Bravo, tu viens de débloquer le badge {{ BadgesDB[notification.variables.badge].name }}</h4>
        </template>
      </slot>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Bouton from '@/components/Bouton'
  import { formatDate, formatDateTime } from '@/functions'
  import BadgesDB from '@/datas/badges.json'
  import SoignantDB from '@/datas/soignants.json'

  export default {
    props: ['typeItem', 'direction', 'date', 'notification'],
    data() {
      return { BadgesDB, SoignantDB }
    },
    components: { Bouton },
    computed: {
      ...mapState(['me']),
      category() {
        if(this.notification.notification_type === "appointment_reminder") {
          return "date";
        } else if (this.notification.notification_type === "child_appointment_reminder") {
          return "date";
        } else if (this.notification.notification_type === "account_creation") {
          return "alerte";
        } else if (this.notification.notification_type === "child_account_creation") {
          return "alerte";
        } else if (this.notification.notification_type === "sub_account_creation") {
          return "alerte";
        } else if (this.notification.notification_type === "caregiver_creation") {
          return "alerte";
        } else if (this.notification.notification_type.indexOf('badge') === 0) {
          return "badge";
        }
      }
    },
    methods: {
      formatDate,
      formatDateTime
    }
  }
</script>

<style>
  .notif {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-bottom: 130px;
  }
  .notif .date {
    padding: 7px 15px;
    background: #CCC;
    display: inline;
    border-radius: 10px;
    font-size: 14px;
    color: white;
    font-weight: 600;
    position: absolute;
    top: 50%;
    margin-top: -17px;
  }
  .notif .content {
    background: white;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    border-radius: 15px;
    padding: 20px;
    width: 450px;
    text-align: left;
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 10px;
  }
  .notif .content:before,
  .notif .content:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 20px 15px 0;
    border-color: transparent #e2e2e2 transparent transparent;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .notif .content:after {
    border-color: transparent #fff transparent transparent;
  }
  .notif .content h4 {
    margin: 0 0 10px;
    font-size: 19px;
  }
  .notif .content p {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 10px;
  }
  .notif .icon {
    display: inline-block;
    background: #c3c3c3;
    border: 3px solid #a28f8f;
    width: 55px;
    height: 55px;
    border-radius: 150px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding: 6px;
  }
  .notif .icon:before {
    content: "\f02d";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    position: relative;
    font-weight: 900;
  }
  .notif.right .badge-img {
    position: absolute;
    max-width: 120px;
    top: 0px;
    right: -30px;
  }
  .notif.left .badge-img {
    position: absolute;
    max-width: 120px;
    top: 0px;
    left: -30px;
  }
  .notif.badge h4 {
    width: 80%;
  }
  .notif.left.badge h4 {
    float: right;
  }

  /* Les types et couleurs */

  .notif.date .date {  background: #de2128; }
  .notif.date .icon {  background: #de2128; border-color: #7f0004;  }
  .notif.date .icon:before { content: "\f073"; }

  .notif.alerte .date { background: #086fab;  }
  .notif.alerte .icon { background: #086fab; border-color: #403592;  }
  .notif.alerte .icon:before { content: "\f0f3"; }
  .notif.alerte .btnPush { background: #086fab;box-shadow: 0px 8px 0px 0px #403592;  }
  .notif.alerte .btnPush:hover { box-shadow: 0px 0px 0px 0px #403592;  }

  .notif.message .date {  background: #4dde44; }
  .notif.message .icon {  background: #4dde44; border-color: #139a0a;  }
  .notif.message .icon:before { content: "\f075"; }
  .notif.message .btnPush { background: #4dde44;box-shadow: 0px 8px 0px 0px #139a0a;  }
  .notif.message .btnPush:hover { box-shadow: 0px 0px 0px 0px #139a0a;  }

  .notif.game .date {  background: #e3e039; color: #414141;}
  .notif.game .icon {  background: #e3e039; border-color: #c2b81b;  }
  .notif.game .icon:before { content: "\f005";color: #414141;}
  .notif.game .btnPush { background: #e3e039;box-shadow: 0px 8px 0px 0px #c2b81b;color: #414141;  }
  .notif.game .btnPush:hover { box-shadow: 0px 0px 0px 0px #c2b81b;  }


  .notif.badge .date { background: #e3e039; color: #414141; }
  .notif.badge .icon { background: #e3e039; border-color: #9f9d12; }
  .notif.badge .icon:before { content: "\f0a3" }

  /* Alignement */

  .notif.right .date {
    left: 50%;
    margin-left: -180px;
  }
  .notif.right .content:before,
  .notif.right  .content:after {
    left: -20px;
  }
  .notif.right .content:after {
    left: -18px;
  }
  .notif.left .date {
    right: 50%;
    margin-right: -180px;
  }
  .notif.left .content {
    margin-left: -515px;
    text-align: right;
  }
  .notif.left .content .btnPush {
    margin-right: 0px;
  }
  .notif.left .content:before,
  .notif.left  .content:after {
    border-width: 15px 0 15px 20px;
    border-color: transparent transparent transparent #e2e2e2;
    right: -20px;
  }
  .notif.left .content:after {
    border-color: transparent transparent transparent #fff;
    right: -18px;
  }
</style>
